import { Link } from "react-router-dom";
import { latestUpdates } from "@/mocks/comics";

export default function LatestUpdates() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100/60">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">
              <i className="ri-time-line text-accent-500 mr-2"></i>最新更新
            </h2>
            <p className="text-sm text-foreground-600 mt-1">实时同步 · 追更不等待</p>
          </div>
          <Link
            to="/category/all"
            className="text-sm text-primary-600 hover:text-primary-700 cursor-pointer font-medium whitespace-nowrap transition-colors"
          >
            查看全部 <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-5">
          {latestUpdates.slice(0, 9).map((comic) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="group flex gap-4 p-3 rounded-lg bg-background-50 hover:bg-background-100 cursor-pointer transition-colors"
              data-product-shop=""
            >
              <div className="w-16 h-20 md:w-20 md:h-28 rounded-md overflow-hidden flex-shrink-0 bg-background-100">
                <img
                  src={comic.cover}
                  alt={comic.title + " - 番茄漫画"}
                  title={comic.title + " - 最新更新"}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="flex-1 min-w-0 flex flex-col justify-between">
                <div>
                  <h3 className="text-sm font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-1 whitespace-nowrap">
                    {comic.title}
                  </h3>
                  <p className="text-xs text-foreground-600 mt-0.5 whitespace-nowrap">{comic.author}</p>
                </div>
                <div>
                  <p className="text-xs text-foreground-700 mt-1 line-clamp-1 whitespace-nowrap">
                    更新至 {comic.chapters_list[0].title}
                  </p>
                  <div className="flex items-center gap-2 mt-1.5">
                    <span className={`text-xs px-1.5 py-0.5 rounded whitespace-nowrap ${
                      comic.status === "完结" ? "bg-secondary-100 text-secondary-800" : "bg-primary-100 text-primary-700"
                    }`}>
                      {comic.status}
                    </span>
                    <span className="text-xs text-foreground-500 whitespace-nowrap">{comic.updatedAt}</span>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}